export default __webpack_public_path__ + "static/media/techsist logo.afd2abf2.png";